import { BaseButton, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { C4Text } from "../text/CustomText";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { useClickOutside } from "../../hooks/useClickOutside";
import ParseUtil from "../../utils/ParseUtil";
import CalendarMenu from "../calendar/CalendarMenu";
import { Theme } from "../../Theme";

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

function CustomDateSelectButton({ currentValue, setValue, values, openedCalendarLeftSide = false }) {
    const firstValue = values && values.length > 0 ? values[0] : null;

    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [dateRange, setDateRange] = useState("");
    const [range, setRange] = useState();

    useEffect(() => {
        const toDate = new Date();

        let fromDate = new Date();
        let rangeString = "";

        switch (currentValue) {
            case "All Date":
                rangeString = "All Date";
                break;

            case "Today":
                // 어제 ~ 오늘
                fromDate.setDate(toDate.getDate() - 1);
                rangeString = ParseUtil.parseDateToString(fromDate) + " - " + ParseUtil.parseDateToString(toDate);
                break;

            case "7 Days":
                fromDate.setDate(toDate.getDate() - 6);
                rangeString = ParseUtil.parseDateToString(fromDate) + " - " + ParseUtil.parseDateToString(toDate);
                break;

            case "30 Days":
                fromDate.setDate(toDate.getDate() - 29);
                rangeString = ParseUtil.parseDateToString(fromDate) + " - " + ParseUtil.parseDateToString(toDate);
                break;

            default:
                rangeString = currentValue;
                break;
        }

        setDateRange(rangeString);
    }, [currentValue]);

    const toggleMenu = () => {
        setIsCalendarOpen((prev) => !prev);
    };

    const menuRef = useRef(null);
    useClickOutside(menuRef, () => {
        if (isCalendarOpen) {
            setIsCalendarOpen(false);
        }
    });

    const setCustomValue = () => {
        setValue(
            (range?.from ? format(range.from, "yyyy-MM-dd") : "") +
                " - " +
                (range?.to ? format(range.to, "yyyy-MM-dd") : "")
        );
    };

    return (
        <MenuContainer ref={menuRef}>
            <BaseButton
                padding={"9px 10px"}
                border={
                    currentValue === firstValue && !isCalendarOpen
                        ? `1px solid ${Theme.color.gray250}`
                        : `1px solid ${Theme.color.indigo500}`
                }
                borderRadius={"8px"}
                backgroundColor={
                    currentValue === firstValue && !isCalendarOpen ? Theme.color.white : Theme.color.indigo500_005
                }
                onClick={() => toggleMenu()}
                hoverBackgroundColor={
                    currentValue === firstValue && !isCalendarOpen ? Theme.color.neutral100 : Theme.color.indigo500_01
                }
            >
                <Row alignItem={"center"} cursor={"pointer"}>
                    <Row alignItem={"flex-start"} cursor={"pointer"}>
                        <CustomIcon
                            iconName={currentValue === firstValue ? "date" : "date_active"}
                            width={"13.5px"}
                            height={"12px"}
                        />
                        <SizedBox width={"7px"} />
                        <C4Text fontColor={currentValue === firstValue ? Theme.color.zinc850 : Theme.color.indigo500}>
                            {dateRange}
                        </C4Text>
                    </Row>
                    <SizedBox width={"4px"} />
                </Row>
            </BaseButton>
            {isCalendarOpen && (
                <CalendarMenu
                    range={range}
                    setRange={setRange}
                    onClose={toggleMenu}
                    setCustomValue={setCustomValue}
                    openedCalendarLeftSide={openedCalendarLeftSide}
                />
            )}
        </MenuContainer>
    );
}

export default CustomDateSelectButton;
